import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANG, RTL_LANGS, SUPPORTED_LANGS } from "./constants";
import { isI18nEnabled } from "./feature-flag";
import arAccountSettings from "./locales/ar/account_settings.json";
import arApiKeys from "./locales/ar/api_keys.json";
import arCommon from "./locales/ar/common.json";
import arCustomFields from "./locales/ar/custom_fields.json";
import arCustomers from "./locales/ar/customers.json";
import arDashboard from "./locales/ar/dashboard.json";
import arDevices from "./locales/ar/devices.json";
import arEvents from "./locales/ar/events.json";
import arLayout from "./locales/ar/layout.json";
import arLists from "./locales/ar/lists.json";
import arLogs from "./locales/ar/logs.json";
import arNotFound from "./locales/ar/not_found.json";
import arRules from "./locales/ar/rules.json";
import arSessions from "./locales/ar/sessions.json";
import arTeamManagement from "./locales/ar/team_management.json";
import arWebhooks from "./locales/ar/webhooks.json";
import enAccountSettings from "./locales/en/account_settings.json";
import enApiKeys from "./locales/en/api_keys.json";
import enCommon from "./locales/en/common.json";
import enCustomFields from "./locales/en/custom_fields.json";
import enCustomers from "./locales/en/customers.json";
import enDashboard from "./locales/en/dashboard.json";
import enDevices from "./locales/en/devices.json";
import enEvents from "./locales/en/events.json";
import enLayout from "./locales/en/layout.json";
import enLists from "./locales/en/lists.json";
import enLogs from "./locales/en/logs.json";
import enNotFound from "./locales/en/not_found.json";
import enRules from "./locales/en/rules.json";
import enSessions from "./locales/en/sessions.json";
import enTeamManagement from "./locales/en/team_management.json";
import enWebhooks from "./locales/en/webhooks.json";

void i18n.use(initReactI18next).init({
	resources: {
		en: {
			common: enCommon,
			layout: enLayout,
			not_found: enNotFound,
			webhooks: enWebhooks,
			custom_fields: enCustomFields,
			api_keys: enApiKeys,
			account_settings: enAccountSettings,
			team_management: enTeamManagement,
			lists: enLists,
			devices: enDevices,
			customers: enCustomers,
			sessions: enSessions,
			events: enEvents,
			dashboard: enDashboard,
			logs: enLogs,
			rules: enRules,
		},
		ar: {
			common: arCommon,
			layout: arLayout,
			not_found: arNotFound,
			webhooks: arWebhooks,
			custom_fields: arCustomFields,
			api_keys: arApiKeys,
			account_settings: arAccountSettings,
			team_management: arTeamManagement,
			lists: arLists,
			devices: arDevices,
			customers: arCustomers,
			sessions: arSessions,
			events: arEvents,
			dashboard: arDashboard,
			logs: arLogs,
			rules: arRules,
		},
	},
	defaultNS: "common",
	ns: [
		"common",
		"layout",
		"not_found",
		"webhooks",
		"custom_fields",
		"api_keys",
		"account_settings",
		"team_management",
		"lists",
		"devices",
		"customers",
		"sessions",
		"events",
		"dashboard",
		"logs",
		"rules",
	],
	lng: DEFAULT_LANG,
	fallbackLng: DEFAULT_LANG,
	supportedLngs: SUPPORTED_LANGS as unknown as string[],
	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: false,
	},
});

const applyDirection = (lng: string) => {
	document.documentElement.lang = lng;
	document.documentElement.dir = (RTL_LANGS as readonly string[]).includes(lng)
		? "rtl"
		: "ltr";
};

applyDirection(i18n.language);
i18n.on("languageChanged", (lng) => {
	if (!isI18nEnabled() && lng !== DEFAULT_LANG) {
		void i18n.changeLanguage(DEFAULT_LANG);
		return;
	}
	applyDirection(lng);
});

export default i18n;
